import mapboxgl from '!mapbox-gl'; // eslint-disable-line import/no-webpack-loader-syntax
import React, { useRef, useEffect, useState } from 'react';
import axios from 'axios'
import Grid from '@mui/material/Grid';
import { useNavigate } from 'react-router-dom';
import history from "history/browser"

import { RedrawMap, DrawSchoolBoundaries } from '../utils/MapUtils';
import MapSidebar from '../components/Map/MapSidebar'
import MapTools from '../components/Map/MapTools'
import CutBlocks from '../components/Map/Tools/CutBlocks';
import SelectBlocks from '../components/Map/Tools/SelectBlocks';
import DeselectBlocks from '../components/Map/Tools/DeselectBlocks';
import { MapContext } from '../store/context';
import SwapBlocks from '../components/Map/Tools/SwapBlocks';
import DataInspectorSidebar from '../components/Map/DataInspectionSidebar';

import * as settings from "../settings"
import { InspectorProvider } from '../components/Map/Inspector';
import { MapMenu } from '../components/Map/MapMenu';

import { Level, Plan, Token } from '../atom/atom'
import {
    useRecoilValue,
    useSetRecoilState,
} from 'recoil';

mapboxgl.accessToken = 'pk.eyJ1Ijoic2RlZGl0b3IiLCJhIjoiY2t5cmZ2NnBpMHRtNzJwbGV1NThjN3A4bCJ9.yDqQGzaidN7N7wPGNMPRzA';

axios.defaults.xsrfHeaderName = "csrftoken";
axios.defaults.xsrfCookieName = "X-CSRFTOKEN";

export default function Map(props) {
    var mySettings = props.mySettings
    const isAuthenticated = useRecoilValue(Token)
    const mapContainer = useRef(null);
    const map = useRef(null);
    const [lng, setLng] = useState(-111.888542);
    const [lat, setLat] = useState(40.955530);
    const [zoom, setZoom] = useState(3);
    const [mapLoad, setMapLoad] = useState(false)
    // const [blockData, setBlockData] = useState({})

    const [tab, setTab] = React.useState(0);
    const [selectedBlocks, setSelectedBlocks] = useState([])
    const [selectedBlockIDs, setSelectedBlockIDs] = useState([])
    const [mode, setMode] = useState('block-info')

    const setLevel = useSetRecoilState(Level)
    const level = useRecoilValue(Level)
    const plan = useRecoilValue(Plan)

    const mapSettings = {
        selectedBlocks: selectedBlocks,
        selectedBlockIDs: selectedBlockIDs,
        mode: mode,
        tab: tab,
        setSelectedBlocks,
        setSelectedBlockIDs,
        setMode,
        setTab,
    }

    const navigate = useNavigate()

    useEffect(() => {
        history.replace('/map')
        let location = history.location
        if (isAuthenticated === false) {
            navigate('/home')
        } else {
            navigate(location.pathname)
        }
    }, [])

    useEffect(() => {
        if (map.current) return; // initialize map only once
        map.current = new mapboxgl.Map({
            container: mapContainer.current,
            style: 'mapbox://styles/mapbox/streets-v11',
            center: [lng, lat],
            zoom: zoom
        })

    }, [])

    // useEffect(() => {
    //     map.current.on('sourcedata', (e) => {
    //         console.log('A sourcedata event occurred.', e.type, e.sourceId);
    //     });
    // }, [])

    useEffect(() => {
        if (map.current) {
            mySettings.setMap(map.current)
            map.current.dragPan.enable();
            map.current.on('load', () => {
                setMapLoad(true)

                map.current.addSource('plan', {
                    type: 'vector',
                    tiles: [`${process.env['REACT_APP_API_SERVER']}/api/geometry/geo/tiles/${plan}/${level}/{z}/{x}/{y}`],
                    minzoom: 0,
                    maxzoom: 18
                });

                map.current.addLayer({
                    id: 'plan-layer',
                    type: 'fill',
                    source: 'plan',
                    'source-layer': 'blockdata',
                    paint: {
                        'fill-opacity': 0.75,
                        'fill-color': ['get', 'color'],
                        'fill-outline-color': '#000'
                    },
                })

                map.current.addLayer({
                    id: 'plan-layer-highlighted',
                    type: 'line',
                    source: 'plan',
                    'source-layer': 'blockdata',
                    paint: {
                        'line-opacity': 1,
                        'line-color': 'rgb(0, 0, 0)',
                        'line-width': 3,
                    },
                    filter: ['in', 'blockgeo_id', '']
                })

                map.current.addSource('school-boundaries', {
                    type: 'vector',
                    tiles: [`${process.env['REACT_APP_API_SERVER']}/api/geometry/plan/${plan}/${level}/school_boundaries/{z}/{x}/{y}`],
                    minzoom: 0,
                    maxzoom: 18
                })

                map.current.addLayer({
                    id: 'school-boundaries',
                    type: 'line',
                    source: 'school-boundaries',
                    "source-layer": 'schoolboundaries',
                    paint: {
                        'line-color': '#000000',
                        'line-width': 2.5,
                    }
                })

                map.current.addSource('blocks-to-cut', {
                    type: 'geojson',
                    data: {
                        type: 'FeatureCollection',
                        features: []
                    }
                })

                map.current.addLayer({
                    id: 'blocks-to-cut',
                    type: 'line',
                    source: 'blocks-to-cut',
                    paint: {
                        'line-color': '#000000',
                        'line-width': 5,
                    }
                })
            })
        }
    });

    useEffect(() => {
        if (map.current) {
            map.current.flyTo({
                center: [lng, lat],
                essential: true,
                zoom: 10,
                speed: 2,
                curve: 1,
            });
        }
    }, [lng, lat])

    useEffect(() => {
        if (map.current) {
            var planLayer = map.current.getSource('plan')
            var bundLayer = map.current.getSource('school-boundaries')
            if (planLayer) {
                map.current.getSource('plan').tiles = [`${settings.API_SERVER}/api/geometry/geo/tiles/${plan}/${level}/{z}/{x}/{y}`]
            }
            if (bundLayer) {
                map.current.getSource('school-boundaries').tiles = [`${process.env['REACT_APP_API_SERVER']}/api/geometry/plan/${plan}/${level}/school_boundaries/{z}/{x}/{y}`]
            }
        }
    }, [level, mapLoad, plan])

    useEffect(() => {
        var planLayer = map.current.getSource('plan')
        var bundLayer = map.current.getSource('school-boundaries')
        if (map.current && planLayer && bundLayer) {
            RedrawMap(map.current)
        }

    }, [level])

    useEffect(() => {
        var bids = []
        var possibleSwaps = mySettings.suggestedSwaps
        for (var b in possibleSwaps) {
            bids.push(possibleSwaps[b].blockgeo_id)
        }
        if (map.current) {
            map.current.on('idle', () => {
                map.current.setFilter('plan-layer-highlighted', ['in', 'blockgeo_id', ...bids])
            })
        }
    }, [mySettings.suggestedSwaps])

    return (
        <div>
            <InspectorProvider>
                <MapContext.Provider value={{
                    map: map.current,
                    plan: plan,
                    settings: mapSettings,
                    level: level
                }}>
                    <Grid container spacing={0}>
                        <Grid item xs={12} sm={4} md={3.5} lg={3} boxShadow={1} sx={{ zIndex: 1000 }}>
                            <MapSidebar mySettings={mySettings} mapSettings={mapSettings} />
                        </Grid>
                        <Grid item xs={12} sm={8} md={8.5} lg={9}>
                            <div
                                ref={mapContainer}
                                className="map-container"
                            />
                            {map.current ?
                                <div>
                                    <MapTools>
                                        <CutBlocks />
                                        <SwapBlocks />
                                    </MapTools>
                                    <MapMenu />
                                </div>
                                : null
                            }
                        </Grid>
                        <DataInspectorSidebar />
                    </Grid>
                </MapContext.Provider>
            </InspectorProvider>
        </div>
    );
}
